import { render, staticRenderFns } from "./AppointmentError.vue?vue&type=template&id=62f29a16"
import script from "./AppointmentError.vue?vue&type=script&lang=js"
export * from "./AppointmentError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports